module.exports = __webpack_public_path__ + "img/logo.8184ad8d.png";